import BaseApi from "@/core/HttpResources/BaseApi";
import AnnoucementPublish from "@/models/annoucement/annoucementPublish.Model";
import Annoucement from '@/models/annoucement/annoucement.Model';
export default class AnnoucementService {
  baseApiPublish = new BaseApi("Annoucements");

  async getPublish(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "getPublished",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  async getAnnouncementIdNationalInterest(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetAnnouncementIdNationalInterest",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  async publishAnnoucement(
    annoucement: AnnoucementPublish
  ): Promise<AnnoucementPublish> {
    return new Promise<AnnoucementPublish>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "Activate/" + annoucement.id,
        annoucement,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  async declineAnnoucement(
    annoucement: AnnoucementPublish
  ): Promise<AnnoucementPublish> {
    return new Promise<AnnoucementPublish>((resolve, reject) =>
      this.baseApiPublish.request(
        "PUT",
        "Deactivate/" + annoucement.id,
        annoucement,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  async getDetailAnnocement(
    id: string|number
  ): Promise<AnnoucementPublish> {
    return new Promise<AnnoucementPublish>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetById",
        null,
        {id:id},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  async getAnnouncementWithEvaluationsTypesById(
    id: string|number
  ): Promise<Annoucement> {
    return new Promise<Annoucement>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetAnnouncementWithEvaluationsTypesById/" + id,
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async validateAnnouncementEvaluationTypeByIdAndType(
    id: number,
    typeId: number
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "ValidateMainAnnouncementEvaluationTypeById/" + id + "/AndTypeId/" + typeId,
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}
